import  getResponseJson from './getresponsejson';

export const workflowService = serviceRoutes => {
  const placeOnHold = (encounterId, reasonId, comment) => {
    const encounterHoldType = 0;

    return fetch(serviceRoutes.placeOnHold, {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        encounterId,
        encounterHoldType,
        isRemove: false,
        holdReasonId: reasonId,
        holdComment: comment
      })
    })
    .then(getResponseJson)
    .then(responseJson => {
      const { result } = responseJson;
      return Promise.resolve(result);
    })
    .catch(e => {
      console.error(e.toString());
    });
  };

  const removeFromHold = encounterId => {
    return fetch(serviceRoutes.removeFromHold, {
      credentials: 'include',
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: encounterId
      })
    })
    .then(getResponseJson)
    .then((/* responseJson */) => {
      return Promise.resolve(null);
    })
    .catch(e => {
      console.error(e.toString());
    });
  };

  const exitEncounter = encounterId => {
    return fetch(serviceRoutes.exitEncounter, {
      credentials: 'include',
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: encounterId
      })
    })
    .then(getResponseJson)
    .then((/* responseJson */) => {
      return Promise.resolve(null);
    })
    .catch(e => {
      console.error(e.toString());
    });
  };

  const finalizeEncounter = encounterId => {
    return fetch(serviceRoutes.finalizeEncounter, {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: encounterId
      })
    })
    .then(getResponseJson)
    .then(responseJson => {
      const { result } = responseJson;
      return Promise.resolve(result);
    })
    .catch(e => {
      console.error(e.toString());
    });
  };

  const unfinalizeEncounter = encounterId => {
    return fetch(serviceRoutes.unfinalizeEncounter, {
      credentials: 'include',
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: encounterId
      })
    })
    .then(getResponseJson)
    .then((/* responseJson */) => {
      return Promise.resolve(null);
    })
    .catch(e => {
      console.error(e.toString());
    });
  };

  const completeEncounter = encounterId => {
    return fetch(serviceRoutes.completeEncounter, {
      credentials: 'include',
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: encounterId
      })
    })
    .then(getResponseJson)
    .then(responseJson => {
      return Promise.resolve(responseJson.result);
    });
  };

  const markEncounterAsInvalid = encounterId => {
    return fetch(serviceRoutes.markEncounterAsInvalid, {
      credentials: 'include',
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: encounterId
      })
    })
    .then(getResponseJson)
    .then(responseJson => {
      return Promise.resolve(responseJson.result);
    });
  };

  return {
    placeOnHold,
    removeFromHold,
    exitEncounter,
    finalizeEncounter,
    unfinalizeEncounter,
    completeEncounter,
    markEncounterAsInvalid,
    serviceRoutes
  };
};

export default workflowService;
